<template>
  <div id="app"
       v-loading="loggedIn && !initApp"
       element-loading-text="Cargando..."
       element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(0, 0, 0, 0.8)">
    <vue-progress-bar></vue-progress-bar>
    <template v-if="loggedIn && (menus.error || parametro.error || user.error)">
      <el-alert
        title="Error conexión"
        type="error"
        :closable="false"
        show-icon>
        <span>Hay un error al conectarse con el servidor, por favor refresque el sitio o contactese con el administrador del sitio</span>
      </el-alert>
    </template>
    <router-view></router-view>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import {Alert} from "element-ui";

export default {
  name: 'app',
  components: {
    [Alert.name]: Alert,
  },
  data: () => ({
    isMenuLoading: false,
  }),
  computed: {
    ...mapState({
      user: state => state.user,
      menus: state => state.menus,
      parametro: state => state.parametro,
      loggedIn: state => state.loggedIn,
      initApp: state => state.initApp
    })
  }
}
</script>
